export const joinUrlParms = (urlParams) =>
    Object.entries(urlParams)
        .filter(([key, value]) => value !== undefined)
        .reduce((acc, [key, value]) => {
            if (Array.isArray(value)) {
                return [...acc, ...value.map((v) => [key, v])];
            } else {
                acc.push([key, value]);
            }
            return acc;
        }, [])
        .reduce((acc, [key, value]) => `${acc}${acc === "" ? "?" : "&"}${key}=${encodeURIComponent(value)}`, "");

const wssMap = {
    [process.env.REACT_APP_LOCAL_HOSTNAME]: process.env.REACT_APP_LOCAL_WS,
    [process.env.NEXT_PUBLIC_REACT_APP_LOCAL_HOSTNAME]: process.env.NEXT_REACT_APP_LOCAL_WS,
    [process.env.REACT_APP_DEV_HOSTNAME]: process.env.REACT_APP_DEV_WS,
    [process.env.NEXT_PUBLIC_REACT_APP_DEV_HOSTNAME]: process.env.NEXT_REACT_APP_DEV_WS,
    [process.env.REACT_APP_UAT_HOSTNAME]: process.env.REACT_APP_UAT_WS,
    [process.env.NEXT_PUBLIC_REACT_APP_UAT_HOSTNAME]: process.env.NEXT_REACT_APP_UAT_WS,
    [process.env.REACT_APP_LIVE_HOSTNAME]: process.env.REACT_APP_LIVE_WS,
    [process.env.NEXT_PUBLIC_REACT_APP_LIVE_HOSTNAME]: process.env.NEXT_REACT_APP_LIVE_WS,
};

let currentHostName = 'localhost';

if (typeof window !== 'undefined')
    currentHostName = window.location.hostname;

export const wsEndpoint = wssMap[currentHostName];